import { cva } from '@vizit/theme';

const containerClasses = cva({
  base: 'flex flex-col gap-4',
});

const cardClasses = cva({
  base: 'flex items-start border border-secondary bg-primary transition-colors duration-[350ms]',
});

const mainScoreClasses = cva({
  base: 'flex flex-col items-center gap-2 shrink-0 border-r border-secondary px-4 pb-3 pt-6 self-stretch transition-colors duration-[350ms]',
});

const metricsClasses = cva({
  base: 'flex flex-1 items-center divide-x divide-secondary transition-colors duration-[350ms]',
});

export { cardClasses, containerClasses, mainScoreClasses, metricsClasses };
